// component for deleting any entity

import React, { FC } from 'react';
import TwDialog from '../TwDialog/TwDialog';
import { ReactComponent as Warning } from '../../assets/icons/warning.svg';
import { TwButton, TwButtonType } from '../TwButtons/TwButtons';
import { Typography } from '@mui/material';

interface TwDeleteOrderTripProps {
  open: boolean;
  fileName: string;
  onClickClose: () => void;
  onDelete: () => void;
}

const TwDeleteOrderTripDoc: FC<TwDeleteOrderTripProps> = ({
  open,
  fileName,
  onClickClose,
  onDelete
}): JSX.Element => {
  return (
    <TwDialog open={open} title="Delete file" onClickClose={onClickClose}>
      <div className="warning">
        <Warning />
        <p className="warning__message">
          Are you sure you want to delete{' '}
          <Typography
            component={'span'}
            sx={{ fontSize: '14px', color: '#6B7280', fontWeight: '700' }}
          >
            {fileName}
          </Typography>
          ? This file will be removed from all associated entities (Order, Trip) and may cause a
          potential loss of information. You can&apos;t undo this action.
        </p>
        <div className="warning__actions">
          <TwButton
            fullwidth={false}
            label="Cancel"
            type={TwButtonType.secondary}
            action={onClickClose}
          />
          <TwButton
            fullwidth={false}
            label="Delete"
            type={TwButtonType.negative}
            action={onDelete}
          />
        </div>
      </div>
    </TwDialog>
  );
};

export default TwDeleteOrderTripDoc;
